














import { AccordionItem } from "@spectrum-web-components/accordion";
import { css } from "lit-element";
import "@spectrum-web-components/accordion/sp-accordion";
import '@spectrum-web-components/action-button/sp-action-button.js';
import '@spectrum-web-components/action-menu/sp-action-menu.js';
import '@spectrum-web-components/avatar/sp-avatar.js';
import '@spectrum-web-components/button/sp-button.js';
import '@spectrum-web-components/icon/sp-icon.js';
import '@spectrum-web-components/link/sp-link.js';
import '@spectrum-web-components/menu/sp-menu.js';
import '@spectrum-web-components/menu/sp-menu-divider.js';
import '@spectrum-web-components/menu/sp-menu-group.js';
import '@spectrum-web-components/menu/sp-menu-item.js';
import '@spectrum-web-components/overlay/active-overlay.js';
import '@spectrum-web-components/overlay/overlay-trigger.js';
import '@spectrum-web-components/sidenav/sp-sidenav.js';
import '@spectrum-web-components/sidenav/sp-sidenav-item.js';
import '@spectrum-web-components/theme/sp-theme.js';
import '@spectrum-web-components/theme/theme-lightest.js';
import '@spectrum-web-components/theme/scale-medium.js';
import '@spectrum-web-components/underlay/sp-underlay.js';
import '@spectrum-web-components/progress-circle/sp-progress-circle';
import '@spectrum-web-components/tooltip/sp-tooltip';
import '@spectrum-web-components/textfield/sp-textfield.js';
import '@spectrum-web-components/field-label/sp-field-label';
import '@spectrum-web-components/popover/sp-popover';
import '@spectrum-web-components/tags/sp-tags.js';
import '@spectrum-web-components/tags/sp-tag.js';

import { mapActions } from 'vuex';

import mainnav from '@adobe/edex/frontend/components/main-nav/main-nav.vue';
import '@adobe/edex/ui/shared/components/edex-banner/edex-banner';
import mainfooter from '@adobe/edex/frontend/components/main-footer/main-footer.vue';
import { EdexAuth } from '@adobe/edex/ui/shared/config/auth';
import { FullStoryUtils } from '@adobe/edex/ui/shared/config/fullstory';
import { formatDocumentTitle } from '@adobe/edex/ui/shared/frontend/utils/seo';
import { WebpSupport } from '@adobe/edex/ui/shared/frontend/utils/imageResize';
import { IMS } from '@adobe/edex/ui/shared/config/ims';
import * as analytics from '@adobe/edex/frontend/api/analytics';
import { Analytics } from '@adobe/edex/ui/shared/config/analytics';
import { getMarketingVehicleInfo } from '@adobe/edex/ui/shared/utils/marketingVehicle';

Object.defineProperty(AccordionItem, "styles", {
    value: [
      ...AccordionItem.styles,
      css`
        #header {
          text-transform: var(
            --spectrum-accordion-item-title-text-transform,
            uppercase
          );
          font-weight: var(
            --spectrum-accordion-item-title-text-font-weight,
            500
          );
        }
      `,
    ],
    writable: false,
  });

customElements.define("sp-accordion-item", AccordionItem);


export default {
  seo: {
    titleTemplate: formatDocumentTitle,
    meta: [
      { charset: 'utf-8' },
      {
        name: 'description',
        content: `Become a member by joining the community of creative educators. Gain complete access to the latest teaching materials and lessons with Adobe Education Exchange.`,
        vmid: 'description',
      },
      {
        name: 'keywords',
        content: `adobe certificate, adobe education, adobe education exchange, free courses, learning platform, free workshops, adobe projects, adobe curriculum`,
      },
      {
        name: 'google-site-verification',
        content: 'iC2gwcXdxDon-WM8llmTFqSkdqvX-38DTJoQDsqWWAU',
      },
      {
        name: 'viewport',
        content:
          'initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, user-scalable=no',
      },
    ],
  },
  components: {
    mainnav,
    mainfooter,
  },
  data: function () {
    return {
      isWebpSupported: false,
    };
  },
  async created() {
    WebpSupport.init().then(on => {
      this.isWebpSupported = on;
    });
    await this.init();
  },
  async mounted() {
    document.body.classList.add('body--edexV3');
    this.handleCampaignEvents();
  },
  methods: {
    ...mapActions('member', ['self']),
    async init() {
      const isAuth = await IMS.isAuthenticated();
      if (isAuth) {
        const member = await this.self();
        // Set the user profile in FullStory, only once
        FullStoryUtils.getInstance().identifyUser(member);
      }
    },
    onClick(e) {
      // global event handler (some btns defined as a markup in localization strings)
      if (e?.target?.classList?.contains('btn-signin')) {
        EdexAuth.signIn();
      }
      if (e?.target?.classList?.contains('btn-join')) {
        EdexAuth.signUp();
      }
    },
    async handleCampaignEvents() {

    const {
      channelInfo,
      campaignInfo,
      landingPage,
    } = await getMarketingVehicleInfo();

    if (channelInfo) {
      analytics.track([{
        event: 'edex.visit.mv',
        payload: {
          mvParams: {
            cid: campaignInfo.id,
            cname: campaignInfo.name,
            cqueryParameter: campaignInfo.queryParameter,
            mv: channelInfo.marketingVehicle,
            mvDetail: channelInfo.marketingVehicleDetail,
            landingPage,
          },
        },
      }]);
    }
  },
  },
};
